import $ from "jquery";
import Chart from "chart.js/auto";
import ColorMap from "../data/ballTypeColor.json";

export const setHitterCanvas = (target_name, pitchData) => {
    const pitches = Object.keys(pitchData).reduce((acc, key) => {
      acc[key] = pitchData[key] !== undefined ? pitchData[key] : [];
      return acc;
    }, {});
  
    const datasets = [];
    for (let key in pitches) {
      datasets.push({
        pointBackgroundColor: ColorMap[key],
        borderWidth: 0,
        borderColor: "#000000",
        data: pitches[key],
      });
    }
  
    const data = {
      datasets: datasets,
    };
  
    const lineImage = new Image();
    lineImage.src = "bg_hitter_line.png";
  
    const pluginLine = {
      id: "custom_canvas_hitter_line_image",
      beforeDraw: (chart) => {
        if (lineImage.complete) {
          const ctx = chart.ctx;
          const { top, left, width, height } = chart.chartArea;
  
          const isPC = $(window).width() > 960;
  
          const image_rwd_width =
            ($(window).width() * lineImage.width) / (isPC ? 1920 : 960);
          const image_rwd_height = image_rwd_width * 0.7489;
  
          const x = left;
          const y = top;
  
          ctx.drawImage(lineImage, x, y, width, height);
        } else {
          lineImage.onload = () => chart.draw();
        }
      },
    };
  
    const isPC = $(window).width() > 960;
  
    const config = {
      type: "bubble",
      data: data,
      plugins: [pluginLine],
      options: {
        responsive: true,
        aspectRatio: 0.95,
        layout: {
          padding: {
            bottom: 60,
          },
        },
        legend: {
          position: "left",
          display: false,
        },
        plugins: {
          legend: false,
          tooltip: false,
        },
        elements: {
          point: {
            pointRadius: isPC ? 2 : 4,
          },
        },
        scales: {
          x: {
            min: -400,
            max: 400,
            ticks: { display: false, stepSize: 100 },
            grid: {
              display: true,
              drawTicks: false,
              borderWidth: 0,
            },
          },
          y: {
            min: -100,
            max: 500,
            ticks: { display: false, stepSize: 100 },
            grid: {
              display: true,
              drawTicks: false,
              borderWidth: 0,
            },
          },
        },
      },
    };
  
    return new Chart($(".hitter_canvas[name=" + target_name + "]"), config);
}

export const setPitcherCanvas = (target_name, pitchData) => {
    const pitches = Object.keys(pitchData).reduce((acc, key) => {
      acc[key] = pitchData[key] !== undefined ? pitchData[key] : [];
      return acc;
    }, {});
  
    var datasets = [];
    for (let key in pitches) {
      datasets.push({
        pointBackgroundColor: ColorMap[key],
        borderWidth: 0,
        borderColor: "#000000",
        data: pitches[key],
      });
    }
    //357*375
    //286*300
    //674*709
  
    const data = {
      datasets: datasets,
    };
  
    const baseImage = new Image();
    baseImage.src = "base.png";
  
    const pluginBase = {
      id: "custom_canvas_base_image",
      beforeDraw: (chart) => {
        if (baseImage.complete) {
          const ctx = chart.ctx;
          const { top, left, width, height } = chart.chartArea;
  
          var isPC = $(window).width() > 960;
  
          var image_rwd_width =
            (($(window).width() * baseImage.width) / (isPC ? 1920 : 960)) *
            (isPC ? 0.78 : 2);
          var image_rwd_height = image_rwd_width * 0.35;
          var border_rwd_height = image_rwd_height * 4.25;
  
          const x = left + width / 2 - image_rwd_width / 2;
          //const y = top + height - image_rwd_height-(image_rwd_height*1.54*$(window).width()/1920) ;
          const y = top + height / 2 + border_rwd_height / 2 + image_rwd_height;
  
          ctx.drawImage(baseImage, x, y, image_rwd_width, image_rwd_height);
        } else {
          baseImage.onload = () => chart.draw();
        }
      },
    };
  
    const borderImage = new Image();
    borderImage.src = "red_border.png";
  
    const pluginBorder = {
      id: "custom_canvas_red_border_image",
      beforeDraw: (chart) => {
        if (borderImage.complete) {
          const ctx = chart.ctx;
          const { top, left, width, height } = chart.chartArea;
  
          var isPC = $(window).width() > 960;
  
          var image_rwd_width =
            (($(window).width() * borderImage.width) / (isPC ? 1920 : 960)) *
            (isPC ? 0.78 : 2);
          var image_rwd_height = image_rwd_width * 1.204;
  
          const x = left + width / 2 - image_rwd_width / 2;
          const y = top + height / 2 - image_rwd_height / 2;
          ctx.drawImage(borderImage, x, y, image_rwd_width, image_rwd_height);
        } else {
          borderImage.onload = () => chart.draw();
        }
      },
    };
  
    const isPC = $(window).width() > 960;
    const config = {
      type: "bubble",
      data: data,
      plugins: [pluginBase, pluginBorder],
      options: {
        responsive: true,
        aspectRatio: 0.95,
        layout: {
          padding: {
            bottom: 60,
          },
        },
        legend: {
          position: "left",
          display: false,
        },
        plugins: {
          legend: false,
          tooltip: false,
        },
        elements: {
          point: {
            pointRadius: isPC ? 2 : 4,
          },
        },
        scales: {
          x: {
            min: -50,
            max: 50,
            ticks: { display: false, stepSize: 5 },
            grid: {
              display: false,
              drawTicks: false,
              borderWidth: 0,
            },
          },
          y: {
            min: -10,
            max: 70,
            ticks: { display: false, stepSize: 5 },
            grid: {
              display: false,
              drawTicks: false,
              borderWidth: 0,
            },
          },
        },
      },
    };
  
    return new Chart($(".pitcher_canvas[name=" + target_name + "]"), config);
}